import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'gatsby-plugin-react-i18next';
import { Buttons } from 'lidya-common-components';
import classNames from 'classnames';
import { useGoto } from './hooks/useGoto';
import './go.to.button.less';

export const GoToButton = function ({ className, isMenuOpen, toggleMenu }) {
  const goToTop = useGoto();

  const onClick = useCallback(
    () => {
      if (isMenuOpen) toggleMenu();
      goToTop();
    },
    [goToTop, isMenuOpen, toggleMenu],
  );

  return (
    <Buttons.Button
      type={Buttons.BUTTON_TYPES.PRIMARY}
      onClick={onClick}
      className={classNames('m-landingPages__gotoButton', className)}
    >
      <Trans>get.loan.label</Trans>
    </Buttons.Button>
  );
};

GoToButton.propTypes = {
  className: PropTypes.string,
};

GoToButton.defaultProps = {
  className: undefined,
};

export default GoToButton;
